import {formatDate, formatDocumentOrganizationUnit} from "utils/valueFormatter.function";
import type {DocumentDetailsProps} from "types/documentData";
import {DocumentDataField, DocumentDataGrid} from "./DocumentDataField.component";
import {DocumentAmountField} from "./DocumentAmount.component";
import {CostUnitsDetails} from "./CostUnitsDetails.component";
import {PreApprovalDetails} from "./PreApprovalDetails.component";
import {getBranchName, getDisplayId} from "./documentData.function";

const InvoiceDocumentDetailsDTO = ({details, warnings, translate}: DocumentDetailsProps) => {
    const displayId = getDisplayId(details);
    const branchName = getBranchName(details);

    return (
        <>
            <DocumentDataGrid>
                {details.description &&
                    <DocumentDataField id="description" wide label={translate("documentData.description")}
                                       value={details.description} warnings={warnings.description}/>}
                {branchName &&
                    <DocumentDataField id="branch" label={translate("documentData.branch")} value={branchName}/>}
                {details.supplierName &&
                    <DocumentDataField id="supplierName" label={translate("documentData.supplierName")}
                                       value={details.supplierName} warnings={warnings.supplierName}/>}
                {details.supplierNumber &&
                    <DocumentDataField id="supplierNumber" label={translate("documentData.supplierNumber")}
                                       value={details.supplierNumber} warnings={warnings.supplierNumber}/>}
                {details.invoiceNumber &&
                    <DocumentDataField id="invoiceNumber" label={translate("documentData.invoiceNumber")}
                                       value={details.invoiceNumber} warnings={warnings.invoiceNumber}/>}
                {details.creditBankAccount &&
                    <DocumentDataField id="creditBankAccount" label={translate("documentData.bankAccount")}
                                       value={details.creditBankAccount} warnings={warnings.creditBankAccount}/>}
                {details.vendorReference &&
                    <DocumentDataField id="vendorReference" label={translate("documentData.vendorReference")}
                                       value={details.vendorReference}/>}
                {displayId &&
                    <DocumentDataField id="documentId" label={translate("documentData.documentID")} value={displayId}/>}
                {!!details.invoiceDate &&
                    <DocumentDataField id="invoiceDate" label={translate("documentData.invoiceDate")}
                                       value={formatDate(details.invoiceDate, null)}/>}
                {!!details.dueDate &&
                    <DocumentDataField id="dueDate" label={translate("documentData.dueDate")}
                                       value={formatDate(details.dueDate, null)}/>}
                {details.amount !== null &&
                    <DocumentAmountField details={details} warnings={warnings.amount} translate={translate}/>}
                {details.documentOrganizationUnit &&
                    <DocumentDataField id="documentOrganizationUnit" label={translate("documentData.documentOrganizationUnit")}
                                       value={formatDocumentOrganizationUnit(details.documentOrganizationUnit)}
                                       warnings={warnings.documentOrganizationUnit}/>}
                {details.paymentPreApprovalDetails &&
                    <PreApprovalDetails paymentDetails={details.paymentPreApprovalDetails} translate={translate}/>}
            </DocumentDataGrid>

            {!!details.documentCostUnitList?.length &&
                <CostUnitsDetails costUnitList={details.documentCostUnitList} translate={translate}/>}
        </>
    );
};

export default InvoiceDocumentDetailsDTO;
